module.exports = __webpack_public_path__ + "static/media/SeroTrackerBloodBank_July_2020.669b184d.png";